import classnames from 'classnames';
import styled from 'styled-components';

import { GameStatus } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { Text16, Text20 } from '@sorare/core/src/atoms/typography';

const Team = styled(Horizontal).attrs({ gap: 0 })`
  font-weight: bold;
  color: var(--c-neutral-600);
  & img {
    width: var(--quadruple-unit);
    height: var(--quadruple-unit);
    margin-right: var(--unit);
  }
  &.won {
    color: var(--c-neutral-1000);
  }
`;

const TeamLogo = styled.img`
  width: var(--quadruple-unit);
`;

const TeamScore = styled(Horizontal).attrs({ gap: 0, center: true })`
  width: var(--quadruple-unit);
  color: var(--c-neutral-600);
  &.won {
    color: var(--c-neutral-1000);
  }
`;

type Props = {
  score: number;
  won: boolean;
  name: string;
  svgUrl: string;
  status: GameStatus;
};
export const TeamRow = ({ status, score, won, name, svgUrl }: Props) => {
  const showScore = [
    GameStatus.playing,
    GameStatus.played,
    GameStatus.suspended,
  ].includes(status as GameStatus);
  return (
    <>
      <Team className={classnames({ won })}>
        <TeamLogo src={svgUrl} alt="" />
        <Text16 bold>{name}</Text16>
      </Team>
      {showScore && (
        <TeamScore className={classnames({ won })}>
          <Text20 bold>{score}</Text20>
        </TeamScore>
      )}
    </>
  );
};
